/**
 * Picks v2 or v1 of the Quote edit page based on the redesign flag.
 */
import React from 'react';
import { useRedesignFlag } from '../../../utils/redesignFlag';
import QuotesAddEditPage   from './QuotesAddEditPage';
import QuotesAddEditPageV2 from './QuotesAddEditPageV2';

export default function QuotesAddEditPageSwitch(props) {
  const [v2] = useRedesignFlag();
  const Component = v2 ? QuotesAddEditPageV2 : QuotesAddEditPage;
  return <Component {...props} />;
}
